import React, {useEffect} from 'react';
// import styled from 'styled-components';

import AnalyticsService from './../../services/AnalyticsService';

import Meta from './../layout/Meta';
import Layout from '../layout/Layout';
import Header from '../layout/Header';
import Section from '../layout/Section';
import Padding from '../layout/Padding';
import Row from './../../common/components/Row';
import Col from './../../common/components/Col';
import Typo from './../../common/components/Typo';
import Icon from "./../../common/components/Icon";


const ChiSiamo = ({layout}) => {
  useEffect(() => {
    AnalyticsService.init();  
  }, []);

  return (
    <Layout layout={layout}>
      <Meta
        title={"Chi Siamo"}
        description={"Autofficina in provincia di Mantova per riparazione e manutenzione di auto e furgoni"}
      />
      <Header 
        uppertext={"Chi Siamo"}
        text={"Autofficina ACS"}
        lowertext={"di Meneghel Mirko e Juri SAS"}
        page="chisiamo"
        alt="Emotional image"
      />


      <Section 
        variant="white" 
        imageDx={"/web/sections/chisiamo-chisiamo.jpg"}
      >
        <Padding top right bottom left>
          <Typo type="h2" align="center">Chi Siamo</Typo>
          <Typo type="p">
            Dal 1999, <b>Autofficina ACS</b> di Meneghel Mirko e Juri S.a.s. è un punto di riferimento per chi cerca un <b>servizio di qualità e affidabilità</b> nella riparazione e manutenzione di <b>auto</b> e <b>furgoni</b>.<br/>
            Grazie alla nostra esperienza e alla passione per i motori, offriamo soluzioni rapide ed efficaci per garantire sicurezza e prestazioni ottimali ai nostri clienti.
          </Typo>  
          
          <Typo type="p">
            La nostra officina è dotata di <b>attrezzature moderne</b> per affrontare qualsiasi tipo di riparazione o manutenzione.<br/>
            Siamo sempre aggiornati sulle <b>nuove tecnologie</b> automobilistiche, comprese le <b>vetture ibride</b>, per offrire un servizio completo e al passo con i tempi.
          </Typo> 
        </Padding>
      </Section>
      <Section variant="lightblue">
        <Padding top right bottom left>
          <Row>
            <Col widthmd={6}>
              <Typo type="p" align="center">
                <Icon name="school" size="50px" />
              </Typo>
              <Typo type="h3" align="center">
                Esperienza e affidabilità
              </Typo>
              <Typo type="p" align="center">
                Oltre 20 anni di attività nel settore
              </Typo>
            </Col>
            <Col widthmd={6}>
              <Typo type="p" align="center">
                <Icon name="service_toolbox" size="50px" />
              </Typo>
              <Typo type="h3" align="center">
                Tecnologia avanzata
              </Typo>
              <Typo type="p" align="center">
                Strumenti diagnostici all'avanguardia per interventi precisi
              </Typo>
            </Col>
            <Col widthmd={6}>
              <Typo type="p" align="center">
                <Icon name="health_and_safety" size="50px" />
              </Typo>
              <Typo type="h3" align="center">
                Qualità e sicurezza
              </Typo>
              <Typo type="p" align="center">
                Utilizziamo solo materiali e ricambi di prima scelta
              </Typo>
            </Col>
            <Col widthmd={6}>
              <Typo type="p" align="center">
                <Icon name="support_agent" size="50px" />
              </Typo>
              <Typo type="h3" align="center">
                Professionalità e trasparenza
              </Typo>
              <Typo type="p" align="center">
                Ogni intervento viene eseguito con la massima attenzione e comunicato in modo chiaro al cliente
              </Typo>
            </Col>
          </Row>
        </Padding>
      </Section>
    </Layout>
  )
}

export default ChiSiamo;
